export default {
  primary: '#00AC17',
  secundary: '#EAEAEA',
  carbon: '#333336',
};
